export const backgroundColors = ["#ffffff", "#f2f2f2", "#e6e6e6", "#d9d9d9", "#cccccc"];

export const expansionHeaders = ["Branch", "Product", "Producer"]
export const orderedGroupingKeys = [
    "BranchSourceOfBusinessAndName",
    "ProductGroup",
    "AgentSourceOfBusinessAndName",
]

export const scorecardHeaders = ["Quote Count", "New Business", "Conversion", "New Business Written Premium"];

export const dataFieldsGroups = ["Ppa", "Commercial", "All"];

export const scorecardDataFields = [
    "All_quotes",
    "All_new_business",
    "All_conversion",
    "All_bound_premium"
]